import React from 'react';
import PropTypes from 'prop-types';

import './HeaderStyle.scss';

const Header = ({ children, size, className, testId, font, bold }) => {
  let headerClass = `header header-${size}${className ? ` ${className}` : ''}`;

  if (font) {
    headerClass = `${headerClass} text-${font}`;
  }

  if (bold) {
    headerClass = `${headerClass} header-bold`;
  }

  return <div data-testid={testId} className={headerClass}>{children}</div>;
};

Header.propTypes = {
  children: PropTypes.node,
  size: PropTypes.string.isRequired,
  className: PropTypes.string,
  testId: PropTypes.string,
  font: PropTypes.oneOf([
    'thin',
    'bold',
    'medium',
    'normal'
  ]),
  bold: PropTypes.bool,
};

export default Header;
